import React from 'react';
import { Col, Row, FormGroup } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { EmailBox, Form } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'

class EmailBoxDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				preset: "lorem@ipsum.com"
			}
		};
	}

	handleChange = (form) => {
		this.setState({ form });
	}

	handleSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	handleCustomValidationValidate = (value) => {
        if (value.indexOf('@gmail.com') !== -1)
            return "Can't use GMAIL accounts.";
    }

	render() {
		return (
			<Box title="EmailBox">
				<Form
					values={this.state.form}
					onChange={this.handleChange}
					onSubmit={this.handleSubmit}>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label>Default</Label>
								<EmailBox name="default" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label>Placeholder</Label>
								<EmailBox name="placeholder" placeholder="Enter your email" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label>Disabled</Label>
								<EmailBox name="disabled" disabled={true} />
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label>Preset</Label>
								<EmailBox name="preset" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label required>Required</Label>
								<EmailBox name="required" required />
							</FormGroup>
						</Col>
						<Col md={4}>
						<FormGroup>
								<Label required>Validation (not @gmail)</Label>
								<EmailBox name="customValidation" onValidate={this.handleCustomValidationValidate} required />
							</FormGroup>
						</Col>
					</Row>
					<hr />
					<div className="btn-toolbar">
						<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
					</div>
				</Form>
			</Box>
		)
	}
}

export default EmailBoxDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/BasicInputs/EmailBoxDemo.js